<template>
  <b-table :data="transactions" hoverable>
    <b-table-column :label="$t('buyNowPayLater.date')" v-slot="props">
      <p class="adjust-top">
        {{
          new Date(props.row.createdAt).toLocaleDateString(
            undefined,
            transactionDateFormat
          )
        }}
      </p>
    </b-table-column>

    <b-table-column :label="$t('buyNowPayLater.client')" v-slot="props">
      <button
        class="button is-light"
        slot="trigger"
        v-if="props.row.user.personalInfo"
      >
        {{
          `${props.row.user.personalInfo.name} ${props.row.user.personalInfo.surname}`
        }}
      </button>

      <p v-else>
        {{ props.row.user._id }}
      </p>
    </b-table-column>

    <b-table-column
      :label="$t('buyNowPayLater.buyNowPayLaterValue')"
      v-slot="props"
    >
      <p class="adjust-top">
        {{
          `${getCurrencySymbolBasedOnCurrency(
            props.row.details.currency
          )}${formatMoney(props.row.details.paymentMethodValue)}`
        }}
      </p>
    </b-table-column>

    <template slot="empty">
      <table-empty-template />
    </template>
  </b-table>
</template>

<script>
import { mask } from "../../mixins/mask";
import tableEmptyTemplate from "../common/TableEmptyTemplate";

export default {
  props: ["transactions"],

  mixins: [mask],

  components: {
    tableEmptyTemplate
  },

  data() {
    return {
      transactionDateFormat: {
        year: "2-digit",
        month: "numeric",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        second: "numeric"
      }
    };
  }
};
</script>

<style scoped>
.adjust-top {
  margin-top: 8px;
}
</style>
